module.exports = __webpack_public_path__ + "static/media/sia-icon.4e2ef8c8.png";